export default "__VITE_ASSET__gNrpAfcj__"